import { FormattedMessage } from 'react-intl';
import { Caption } from '../../../components/atoms/Text/Text';
import { useConfiguration } from '../../../components/ApplicationProviders/ConfigurationProvider/ConfigurationProvider';
import { H1 } from '../../../components/atoms/Heading/Heading';
import { Button } from '../../../components/atoms/Button/Button';
import { ContentBody } from '../../../components/atoms/ContentBody/ContentBody';
import { Footer } from '../../../components/atoms/Footer/Footer';
import { ScreenWrapper } from '../../../components/atoms/ScreenWrapper/ScreenWrapper';
import { Stack } from '../../../components/atoms/Stack/Stack';
import { ApplicationUnverifiedLabel } from '../../../components/molecules/ApplicationUnverifiedLabel/ApplicationUnverifiedLabel';
import { Header } from '../../../components/organisms/Header/Header';
import { PageView } from '../../../models/analytics';
import { usePageViewEvents as usePageViewEventsImport } from '../../../core/Analytics/usePageViewEvents';
import { messages } from '../../messages';
import { IconContainer, RowContainer, TextContainer } from './NetflixConsentScreen.styles';
import { SignUpIcon } from './SignUpIcon';
import { PaymentIcon } from './PaymentIcon';
import { ConnectToBankIcon } from './ConnectToBankIcon';

export type NetflixConsentScreenProps = {
  onConsent: () => void;
  isClientVerified: boolean;
  usePageViewEvents?: ({ pageView }: { pageView: PageView }) => void;
};

export const NetflixConsentScreen = ({
  onConsent,
  isClientVerified,
  usePageViewEvents = usePageViewEventsImport,
}: NetflixConsentScreenProps) => {
  const { activeTheme } = useConfiguration();
  const { primaryColor, backgroundColor } = activeTheme.colors;

  usePageViewEvents({
    pageView: PageView.NETFLIX_CONSENT_SCREEN,
  });

  return (
    <ScreenWrapper>
      <Header pageView={PageView.NETFLIX_CONSENT_SCREEN} onBack={undefined} />
      <ContentBody data-testid="pay-netflix-consent-screen">
        <H1>
          <FormattedMessage {...messages.verifyWithBank} />
        </H1>
        <ApplicationUnverifiedLabel isVerified={isClientVerified} />
        <Stack justifyContent="flex-start">
          <RowContainer marginTop="xxsmall" skipLeftPadding>
            <IconContainer>
              <ConnectToBankIcon primaryColor={primaryColor} backgroundColor={backgroundColor} />
            </IconContainer>
            <TextContainer>
              <Caption>
                <FormattedMessage {...messages.connectMessage} />
              </Caption>
            </TextContainer>
          </RowContainer>
          <RowContainer marginTop="xxsmall" skipLeftPadding>
            <IconContainer>
              <PaymentIcon primaryColor={primaryColor} />
            </IconContainer>
            <TextContainer>
              <Caption>
                <FormattedMessage {...messages.paymentMessage} />
              </Caption>
            </TextContainer>
          </RowContainer>
          <RowContainer marginTop="xxxsmall" skipLeftPadding>
            <IconContainer>
              <SignUpIcon primaryColor={primaryColor} />
            </IconContainer>
            <TextContainer>
              <Caption>
                <FormattedMessage {...messages.signupMessage} />
              </Caption>
            </TextContainer>
          </RowContainer>
        </Stack>
        <Footer stickToBottom>
          <Button
            size="large"
            type="submit"
            color="primary"
            variant="contained"
            onClick={onConsent}
          >
            <FormattedMessage {...messages.connectToBank} />
          </Button>
        </Footer>
      </ContentBody>
    </ScreenWrapper>
  );
};
